// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ModuleList } from "#/components/module_list/ModuleList";

import ModuleBase from "#/common/ModuleBase";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ModuleList,
  },
})
export class MoreInformation extends ModuleBase {
  private isOpen = false;

  private isOpenDelayed = false;

  getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  @Watch("isOpen")
  public onIsOpenChanged(newValue) {
    if (newValue) {
      setTimeout(() => {
        this.isOpenDelayed = true;
      }, 500);
    } else {
      this.isOpenDelayed = false;
    }
  }
}
